import { render, staticRenderFns } from "./RecipientGroupsIndex.vue?vue&type=template&id=42192872&scoped=true&"
import script from "./RecipientGroupsIndex.vue?vue&type=script&lang=js&"
export * from "./RecipientGroupsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42192872",
  null
  
)

export default component.exports